import React from 'react'
import { Redirect, NavLink } from 'react-router-dom'
import {
  Segment,
  Table,
  Grid,
  Dropdown,
  Header,
  Icon,
  Button,
  Loader,
} from 'semantic-ui-react'

import find from 'lodash/find'

import './Classes.css'

const _ = {
  find: find
}

const ClassesPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'levelHead') {
    const {
      column, direction, sections,
      schoolYearId, sectionId, sectionSubjects
    } = props;
    if (!props.currentSchoolYear && sections) return null;
    let optionsSchoolYears;
    if (props.schoolYears) {
      optionsSchoolYears = props.schoolYears.map((schoolYear,index) => {
        return (
            { key: schoolYear.schoolYearId, value: schoolYear.schoolYearId, text: schoolYear.name }
        )
      })
    }

    let optionsSections;
    if (sections) {
      optionsSections = sections.map((section,index) => {
        const displayText = section.gradeLevel + ' - ' + section.name;
        return (
            { key: section.sectionId, value: section.sectionId, text: displayText }
        )
      })
    }

    let classSectionBody;

    const subjectsTable = sectionSubjects.map((sectionSubject, key )=> {
      const firstQuarterGrade = _.find(sectionSubject.details, { quarter: 1, type: 'grade' });
      const secondQuarterGrade = _.find(sectionSubject.details, { quarter: 2, type: 'grade' });
      const thirdQuarterGrade = _.find(sectionSubject.details, { quarter: 3, type: 'grade' });
      const fourthQuarterGrade = _.find(sectionSubject.details, { quarter: 4, type: 'grade' });

      const firstQuarterConduct = _.find(sectionSubject.details, { quarter: 1, type: 'conduct' });
      const secondQuarterConduct = _.find(sectionSubject.details, { quarter: 2, type: 'conduct' });
      const thirdQuarterConduct = _.find(sectionSubject.details, { quarter: 3, type: 'conduct' });
      const fourthQuarterConduct = _.find(sectionSubject.details, { quarter: 4, type: 'conduct' });

      const section = _.find(sections, { sectionId: sectionId });
      const detailAttendance1 = _.find(section.details, { type: 'attendance', quarter: 1 });
      const detailAttendance2 = _.find(section.details, { type: 'attendance', quarter: 2 });
      const detailAttendance3 = _.find(section.details, { type: 'attendance', quarter: 3 });
      const detailAttendance4 = _.find(section.details, { type: 'attendance', quarter: 4 });

      const detailConduct1 = _.find(section.details, { type: 'conduct', quarter: 1 });
      const detailConduct2 = _.find(section.details, { type: 'conduct', quarter: 2 });
      const detailConduct3 = _.find(section.details, { type: 'conduct', quarter: 3 });
      const detailConduct4 = _.find(section.details, { type: 'conduct', quarter: 4 });

      const detailRemark1 = _.find(section.details, { type: 'remark', quarter: 1 });
      const detailRemark2 = _.find(section.details, { type: 'remark', quarter: 2 });
      const detailRemark3 = _.find(section.details, { type: 'remark', quarter: 3 });
      const detailRemark4 = _.find(section.details, { type: 'remark', quarter: 4 });

      classSectionBody = (
        <Table.Row key={key} className='sections-table-row'>
          <Table.Cell textAlign='center'>
            {section.gradeLevel} - {section.name}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/attendances/${schoolYearId}/${sectionId}?quarter=1`}>
              {detailAttendance1.status === 'Approved'? <Icon name='check circle' color='green'/> : detailAttendance1.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center' >
            <NavLink to={`/classconducts/${sectionId}?quarter=1`}>
              {detailConduct1.status === 'Approved'? <Icon name='check circle' color='green'/> : detailConduct1.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center' >
            <NavLink to={`/remarks/${sectionId}?quarter=1`}>
              {detailRemark1.status === 'Approved'? <Icon name='check circle' color='green'/> : detailRemark1.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/attendances/${schoolYearId}/${sectionId}?quarter=2`}>
              {detailAttendance2.status === 'Approved'? <Icon name='check circle' color='green'/> : detailAttendance2.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center' >
            <NavLink to={`/classconducts/${sectionId}?quarter=2`}>
              {detailConduct2.status === 'Approved'? <Icon name='check circle' color='green'/> : detailConduct2.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center' >
            <NavLink to={`/remarks/${sectionId}?quarter=2`}>
              {detailRemark2.status === 'Approved'? <Icon name='check circle' color='green'/> : detailRemark2.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/attendances/${schoolYearId}/${sectionId}?quarter=3`}>
              {detailAttendance3.status === 'Approved'? <Icon name='check circle' color='green'/> : detailAttendance3.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center' >
            <NavLink to={`/classconducts/${sectionId}?quarter=3`}>
              {detailConduct3.status === 'Approved'? <Icon name='check circle' color='green'/> : detailConduct3.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center' >
            <NavLink to={`/remarks/${sectionId}?quarter=3`}>
              {detailRemark3.status === 'Approved'? <Icon name='check circle' color='green'/> : detailRemark3.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/attendances/${schoolYearId}/${sectionId}?quarter=4`}>
              {detailAttendance4.status === 'Approved'? <Icon name='check circle' color='green'/> : detailAttendance4.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center' >
            <NavLink to={`/classconducts/${sectionId}?quarter=4`}>
              {detailConduct4.status === 'Approved'? <Icon name='check circle' color='green'/> : detailConduct4.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center' >
            <NavLink to={`/remarks/${sectionId}?quarter=4`}>
              {detailRemark4.status === 'Approved'? <Icon name='check circle' color='green'/> : detailRemark4.status}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      )

      return (
        <Table.Row key={key} className='sections-table-row'>
          <Table.Cell>{sectionSubject.subject.name}</Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/grades/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=1`}>
              {firstQuarterGrade.status === 'Approved'? <Icon name='check circle' color='green'/> : firstQuarterGrade.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/conducts/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=1`}>
              {firstQuarterConduct.status === 'Approved'? <Icon name='check circle' color='green'/> : firstQuarterConduct.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/grades/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=2`}>
              {secondQuarterGrade.status === 'Approved'? <Icon name='check circle' color='green'/> : secondQuarterGrade.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/conducts/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=2`}>
              {secondQuarterConduct.status === 'Approved'? <Icon name='check circle' color='green'/> : secondQuarterConduct.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/grades/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=3`}>
              {thirdQuarterGrade.status === 'Approved'? <Icon name='check circle' color='green'/> : thirdQuarterGrade.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/conducts/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=3`}>
              {thirdQuarterConduct.status === 'Approved'? <Icon name='check circle' color='green'/> : thirdQuarterConduct.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/grades/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=4`}>
              {fourthQuarterGrade.status === 'Approved'? <Icon name='check circle' color='green'/> : fourthQuarterGrade.status}
            </NavLink>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <NavLink to={`/conducts/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=4`}>
              {fourthQuarterConduct.status === 'Approved'? <Icon name='check circle' color='green'/> : fourthQuarterConduct.status}
            </NavLink>
          </Table.Cell>

        </Table.Row>
      );
    });

    const headers = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            rowSpan='3'
            textAlign='center'
            sorted={column === 'name' ? direction : null}
            onClick={() => props.handleSort('name')}
          >
            Subjects
          </Table.HeaderCell>
          <Table.HeaderCell colSpan='10' textAlign='center'>Status</Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell textAlign='center' className='section-subject-first' colSpan='2'>1st Quarter</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' colSpan='2'>2nd Quarter</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' colSpan='2'>3rd Quarter</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' colSpan='2'>4th Quarter</Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell textAlign='center' className='section-subject-first'>Academic</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' >Conduct</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' >Academic</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' >Conduct</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' >Academic</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' >Conduct</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' >Academic</Table.HeaderCell>
          <Table.HeaderCell textAlign='center' >Conduct</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    )

    return (
      <div>
        <Segment>
          {
            props.loaded ?
            <div>
            <Grid centered columns={5}>
              <Grid.Column>
                <Dropdown
                  selection
                  name='schoolYearId'
                  options={optionsSchoolYears}
                  onChange={props.handleChange}
                  value={schoolYearId}
                />
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  selection
                  search
                  name='sectionId'
                  placeholder='Section'
                  options={optionsSections}
                  onChange={props.handleChange}
                  value={sectionId}
                />
              </Grid.Column>
            </Grid>

            {
              sectionSubjects.length === 0 ?
              <Segment placeholder>
                <Header icon>
                  <Icon name='database' />
                  Select a section or populate the section with subjects.
                </Header>
                <Button primary>Section Page</Button>
              </Segment> :
              <div className='classes-div-table'>
                <Table celled>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell
                        rowSpan='3'
                        textAlign='center'
                        sorted={column === 'name' ? direction : null}
                        onClick={() => props.handleSort('name')}
                      >
                        Class
                      </Table.HeaderCell>
                      <Table.HeaderCell colSpan='10' textAlign='center'>Status</Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                      <Table.HeaderCell textAlign='center' className='section-subject-first' colSpan='3'>1st Quarter</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' colSpan='3'>2nd Quarter</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' colSpan='3'>3rd Quarter</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' colSpan='3'>4th Quarter</Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                      <Table.HeaderCell textAlign='center' className='section-subject-first'>Attendance</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Conduct</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Remark</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Attendance</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Conduct</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Remark</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Attendance</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Conduct</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Remark</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Attendance</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Conduct</Table.HeaderCell>
                      <Table.HeaderCell textAlign='center' >Remark</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {classSectionBody}
                  </Table.Body>
                </Table>

                <Table celled sortable striped compact size='small'>
                  {headers}

                  <Table.Body>{subjectsTable}</Table.Body>
                </Table>

              </div>
            }
          </div> :
          <Loader active inline='centered' />
          }


        </Segment>
      </div>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default ClassesPV;
